import React from 'react';
import { Icon } from 'semantic-ui-react';
import { defineMessages, FormattedMessage } from 'react-intl';
import moment from 'moment';
import { DATE_FORMAT } from '../../constants';
import textComponent from './textComponent';

const messages = defineMessages({
  'title': {
    id: 'alertConnector.title',
    defaultMessage: 'Alerts'
  },
  'description': {
    id: 'alertConnector.description',
    defaultMessage: 'Alerts allow predicted faults to be surfaced in real time'
  },
  'columns.name.title': {
    id: 'alertConnector.columns.name.title',
    defaultMessage: 'Name'
  },
  'columns.status.title': {
    id: 'alertConnector.columns.status.title',
    defaultMessage: 'Status'
  },
  'columns.status.pending': {
    id: 'alertConnector.columns.status.pending',
    defaultMessage: 'Pending'
  },
  'columns.status.validated': {
    id: 'alertConnector.columns.status.validated',
    defaultMessage: 'Validated'
  },
  'columns.status.invalid': {
    id: 'alertConnector.columns.status.invalid',
    defaultMessage: 'Invalid'
  },
  'columns.lastSeen.title': {
    id: 'alertConnector.columns.lastSeen.title',
    defaultMessage: 'Last Seen'
  },
  'columns.lastSeen.never': {
    id: 'alertConnector.columns.lastSeen.never',
    defaultMessage: 'Never'
  },
  'form.name.label': {
    id: 'alertConnector.form.name.label',
    defaultMessage: 'Name'
  },
  'form.name.placeholder': {
    id: 'alertConnector.form.name.placeholder',
    defaultMessage: 'Name'
  },
  'type.prophes.name': {
    id: 'alertConnector.type.prophes.name',
    defaultMessage: 'PROPHES'
  },
  'type.phalanx.name': {
    id: 'alertConnector.type.phalanx.name',
    defaultMessage: 'PHALANX Digital Operations Platform'
  },
  'type.smtp.name': {
    id: 'alertConnector.type.smtp.name',
    defaultMessage: 'SMTP'
  },
  'type.smtp.options.template.placeholder': {
    id: 'alertConnector.type.smtp.options.template.placeholder',
    defaultMessage: 'Template'
  },
  'type.smtp.options.template.label': {
    id: 'alertConnector.type.smtp.options.template.label',
    defaultMessage: 'Template'
  }
});

const validationStatusValues = {
  0: {
    cell: 'warning',
    icon: 'attention',
    name: 'pending'
  },
  1: {
    cell: 'positive',
    icon: 'checkmark',
    name: 'validated'
  },
  2: {
    cell: 'error',
    icon: 'attention',
    name: 'invalid'
  }
};

export default {
  apiPath: 'alertconnector',
  pageUrl: 'alerts',
  icon: 'bell outline',
  isConnector: true,
  hideMenu: true,
  messages,
  textComponent,
  columns: [
    {
      name: 'name',
      width: 3,
      render: ({ name }) => name
    },
    {
      name: 'status',
      width: 3,
      props: ({ validationStatus = 0 }) => ({ [validationStatusValues[validationStatus].cell]: true }),
      render: ({ validationStatus = 0 }) => (
        <div>
          <Icon name={validationStatusValues[validationStatus].icon} /><FormattedMessage {...messages[`columns.status.${validationStatusValues[validationStatus].name}`]} />
        </div>
      )
    },
    {
      name: 'lastSeen',
      width: 3,
      render: ({ lastSeen }) => lastSeen ? moment(lastSeen).format(DATE_FORMAT) : <FormattedMessage {...messages['columns.lastSeen.never']} />
    }
  ],
  form: [
    {
      name: 'name',
      type: 'input'
    },
    {
      type: 'types'
    }
  ],
  createEntity: values => ({
    id: values.name,
    name: values.name,
    type: values.type,
    settings: values.settings || {},
    unitId: null
  }),
  populateForm: entity => ({
    name: entity.name,
    type: entity.type,
    settings: entity.settings
  })
};
